export const environment = {
	production: false,
	// apiHost: 'https://5r1neek9z5.execute-api.ap-south-1.amazonaws.com/Prod',
    apiHost : 'https://69na5an4sf.execute-api.ap-south-1.amazonaws.com/Prod'
};


